webpackJsonp([0],{

/***/ "+SfR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/IOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    // balloon title
    title: {
      default: '',
      type: String
    },

    // position: bottom-right, bottom-left, top-right, or top-left
    position: {
      default: 'bottom-right',
      type: String
    },

    // enable the css transform: scale() effect
    zooming: {
      default: false,
      type: Boolean
    },

    // hide the close (x) icon on the balloon
    hideCloseButton: {
      default: false,
      type: Boolean
    },

    // hide the concise (chevron) icons on the balloon
    hideConciseButton: {
      default: false,
      type: Boolean
    },

    // when balloon is created it will have this initial 'concise' state
    initiallyConcise: {
      default: false,
      type: Boolean
    },

    // when balloon is maximized, it will still have the close button
    showCloseWhenMaximized: {
      default: false,
      type: Boolean
    },

    //* vb internal props *//

    // keep track of state with multiple balloons
    balloonState: {
      default: function _default() {
        return {
          maximized: null
        };
      },

      type: Object
    },

    // remember the original balloon object to store in the balloon state
    balloon: {
      default: function _default() {
        return {};
      },

      type: Object
    },

    // force the minimized state, used in the balloon set dock
    forceMinimized: {
      default: false,
      type: Boolean
    }
  },

  data: function data() {
    return {
      concise: this.initiallyConcise,
      closed: false
    };
  },


  watch: {
    'balloonState.maximized': function balloonStateMaximized(n, o) {
      // if maximized balloon changed from this one trigger a minimize event
      if (o === this.balloon && n !== this.balloon) {
        this.$emit('minimize', this);
        // else if maximized balloon changed to this one trigger a maximize event
      } else if (o !== this.balloon && n === this.balloon) {
        this.$emit('maximize', this);
      }
    }
  },

  computed: {
    classes: function classes() {
      return ['vb', this.position ? 'vb-' + this.position : '', this.concise ? 'vb-concise' : '', this.maximized ? 'vb-maximized' : '', !this.maximized && this.zooming ? 'vb-zoomed-out' : ''];
    },
    maximized: function maximized() {
      return this.balloonState.maximized === this.balloon && !this.forceMinimized;
    }
  },

  methods: {
    close: function close() {
      this.closed = true;
      this.$emit('close', this);
    },
    open: function open() {
      this.closed = false;
      this.$emit('open', this);
    },
    maximize: function maximize() {
      this.balloonState.maximized = this.balloon;
    },
    minimize: function minimize() {
      this.balloonState.maximized = null;
    }
  }
});

/***/ }),

/***/ "3XN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DemoMultiple_vue__ = __webpack_require__("EEU8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbde884c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DemoMultiple_vue__ = __webpack_require__("XSNN");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("h7OX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DemoMultiple_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbde884c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DemoMultiple_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "demo/DemoMultiple.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DemoMultiple.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dbde884c", Component.options)
  } else {
    hotAPI.reload("data-v-dbde884c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8mh2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "vb-transition" } }, [
    !_vm.closed
      ? _c(
          "div",
          { staticClass: "vb-wrapper" },
          [
            _c("div", { class: _vm.classes }, [
              _c("div", { staticClass: "vb-header" }, [
                _c(
                  "div",
                  { staticClass: "vb-title", on: { click: _vm.maximize } },
                  [_vm._v(_vm._s(_vm.title))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "vb-buttons" }, [
                  _vm.concise && !_vm.maximized && !_vm.hideConciseButton
                    ? _c("i", {
                        staticClass: "fa fa-chevron-up",
                        attrs: { "aria-hidden": "true" },
                        on: {
                          click: function($event) {
                            _vm.concise = false
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.concise && !_vm.maximized && !_vm.hideConciseButton
                    ? _c("i", {
                        staticClass: "fa fa-chevron-down",
                        attrs: { "aria-hidden": "true" },
                        on: {
                          click: function($event) {
                            _vm.concise = true
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.maximized
                    ? _c("i", {
                        staticClass: "fa fa-compress",
                        attrs: { "aria-hidden": "true" },
                        on: { click: _vm.minimize }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.showCloseWhenMaximized || !_vm.maximized) &&
                  !_vm.hideCloseButton
                    ? _c("i", {
                        staticClass: "fa fa-close",
                        attrs: { "aria-hidden": "true" },
                        on: { click: _vm.close }
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vb-content" }, [
                _c(
                  "div",
                  { staticClass: "vb-content-slot" },
                  [_vm._t("default")],
                  2
                ),
                _vm._v(" "),
                !_vm.maximized
                  ? _c(
                      "div",
                      {
                        staticClass: "vb-minimized-overlay",
                        on: { click: _vm.maximize }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-expand",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("transition", { attrs: { name: "vb-transition" } }, [
              _vm.maximized
                ? _c("div", {
                    staticClass: "vb-maximized-overlay",
                    on: { click: _vm.minimize }
                  })
                : _vm._e()
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d3d3d36", esExports)
  }
}

/***/ }),

/***/ "EEU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__("lVK7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BalloonSet: __WEBPACK_IMPORTED_MODULE_0__src_index__["b" /* BalloonSet */]
  },

  data: function data() {
    return {
      balloons: [
      // Each balloon object can contain any props used in the balloon
      // component (other than the position prop that should be set on the
      // BalloonSet component instead). Events will also be propagated to
      // the balloon component from the nested 'on' object.
      {
        key: 1,
        videoId: '0Bmhjf0rKe8',
        title: 'One Cute Cat',
        on: {
          maximize: function maximize(balloonRef) {
            console.log('maximized', balloonRef);
          },
          minimize: function minimize(balloonRef) {
            console.log('minimized', balloonRef);
          }
        }
      }, { key: 2, videoId: '28xjtYY3V3Q', title: 'And Some Cute Dogs!' }]
    };
  }
});

/***/ }),

/***/ "IWl9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BalloonSet_vue__ = __webpack_require__("zqL5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21950e7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_BalloonSet_vue__ = __webpack_require__("Rzeg");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BalloonSet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21950e7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_BalloonSet_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/BalloonSet.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BalloonSet.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-21950e7c", Component.options)
  } else {
    hotAPI.reload("data-v-21950e7c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PODR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QTap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Balloon_vue__ = __webpack_require__("/IOY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3d3d36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Balloon_vue__ = __webpack_require__("8mh2");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Balloon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3d3d36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Balloon_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Balloon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Balloon.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1d3d3d36", Component.options)
  } else {
    hotAPI.reload("data-v-1d3d3d36", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rzeg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vb-set" },
    [
      _c("transition", { attrs: { name: "vb-transition" } }, [
        _vm.maximizedBalloon
          ? _c(
              "div",
              { ref: "maximized", staticClass: "vb-set-maximized" },
              [
                _c(
                  "balloon",
                  _vm._b(
                    {
                      key: _vm.maximizedBalloon.key,
                      attrs: {
                        balloonState: _vm.balloonState,
                        balloon: _vm.maximizedBalloon,
                        position: null
                      }
                    },
                    "balloon",
                    _vm.maximizedBalloon,
                    false
                  ),
                  [_vm._t("default", null, null, _vm.maximizedBalloon)],
                  2
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.classes },
        _vm._l(_vm.balloons, function(balloon) {
          return _c(
            "balloon",
            _vm._g(
              _vm._b(
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        balloon !== _vm.maximizedBalloon ||
                        _vm.dockKeepMaximized,
                      expression:
                        "balloon !== maximizedBalloon || dockKeepMaximized"
                    }
                  ],
                  key: balloon.key,
                  staticClass: "vb-multiple",
                  attrs: {
                    balloonState: _vm.balloonState,
                    balloon: balloon,
                    position: null,
                    "force-minimized": true
                  }
                },
                "balloon",
                balloon,
                false
              ),
              balloon.on
            ),
            [_vm._t("default", null, null, balloon)],
            2
          )
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21950e7c", esExports)
  }
}

/***/ }),

/***/ "S8VD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__ = __webpack_require__("gxQM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71377baa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__ = __webpack_require__("mQeu");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("PODR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71377baa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "demo/Demo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Demo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71377baa", Component.options)
  } else {
    hotAPI.reload("data-v-71377baa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TB7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "demo" } },
    [
      _c("link", {
        attrs: {
          href:
            "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css",
          rel: "stylesheet",
          integrity:
            "sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN",
          crossorigin: "anonymous"
        }
      }),
      _vm._v(" "),
      _c(
        "balloon",
        {
          attrs: {
            title: "One Cute Cat",
            position: "bottom-right",
            zooming: true
          },
          on: { maximize: _vm.playVideo, minimize: _vm.pauseVideo }
        },
        [
          _c("template", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("Custom Header")
          ]),
          _vm._v(" "),
          _c("youtube", {
            ref: "player",
            staticClass: "video",
            attrs: { "video-id": _vm.videoId }
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-430be292", esExports)
  }
}

/***/ }),

/***/ "WNxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index__ = __webpack_require__("lVK7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Balloon: __WEBPACK_IMPORTED_MODULE_0__src_index__["a" /* Balloon */]
  },

  data: function data() {
    return {
      videoId: '0Bmhjf0rKe8'
    };
  },


  methods: {
    playVideo: function playVideo() {
      this.$refs.player.player.playVideo();
    },
    pauseVideo: function pauseVideo() {
      this.$refs.player.player.pauseVideo();
    }
  }
});

/***/ }),

/***/ "X+yM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XSNN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "demo" } },
    [
      _c("link", {
        attrs: {
          href:
            "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css",
          rel: "stylesheet",
          integrity:
            "sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN",
          crossorigin: "anonymous"
        }
      }),
      _vm._v(" "),
      _c("balloon-set", {
        attrs: { position: "bottom-right", balloons: _vm.balloons },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(balloon) {
              return [
                _c("youtube", {
                  staticClass: "video",
                  attrs: { "video-id": balloon.videoId }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-dbde884c", esExports)
  }
}

/***/ }),

/***/ "gxQM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "h7OX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iXgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed__ = __webpack_require__("5/be");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Demo__ = __webpack_require__("S8VD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DemoSingle__ = __webpack_require__("si5R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DemoMultiple__ = __webpack_require__("3XN/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__("/ocq");
// This file will build the demo

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var router = new __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]({
  routes: [{ name: 'single', path: '/', alias: '/single', component: __WEBPACK_IMPORTED_MODULE_3__DemoSingle__["a" /* default */] }, { name: 'multiple', path: '/multiple', component: __WEBPACK_IMPORTED_MODULE_4__DemoMultiple__["a" /* default */] }]
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<Demo/>',
  components: { Demo: __WEBPACK_IMPORTED_MODULE_2__Demo__["a" /* default */] },
  router: router
});

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Balloon__ = __webpack_require__("QTap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BalloonSet__ = __webpack_require__("IWl9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_plugin_scss__ = __webpack_require__("X+yM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_plugin_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_plugin_scss__);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Balloon__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__components_BalloonSet__["a"]; });
// This file will build the plugin






/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__components_Balloon__["a" /* default */]);



/***/ }),

/***/ "mQeu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "demo" } },
    [
      _c(
        "div",
        { staticClass: "links" },
        [
          _c("router-link", { attrs: { to: { name: "single" } } }, [
            _vm._v("Single Balloon")
          ]),
          _vm._v(" "),
          _c("router-link", { attrs: { to: { name: "multiple" } } }, [
            _vm._v("Multiple Balloons")
          ]),
          _vm._v(" "),
          _c(
            "a",
            { attrs: { href: "https://github.com/kevinwarne/vue-balloon" } },
            [_vm._v("Github")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71377baa", esExports)
  }
}

/***/ }),

/***/ "si5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DemoSingle_vue__ = __webpack_require__("WNxM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430be292_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DemoSingle_vue__ = __webpack_require__("TB7G");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("+SfR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DemoSingle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430be292_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_DemoSingle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "demo/DemoSingle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DemoSingle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-430be292", Component.options)
  } else {
    hotAPI.reload("data-v-430be292", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zqL5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Balloon__ = __webpack_require__("QTap");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      balloonState: {
        maximized: null
      }
    };
  },


  components: {
    Balloon: __WEBPACK_IMPORTED_MODULE_0__Balloon__["a" /* default */]
  },

  props: {
    // position: bottom-right, bottom-left, top-right, or top-left
    // (overrides the Balloon component position)
    position: {
      default: 'bottom-right',
      type: String
    },

    // Balloon component data objects array, each object can contain props
    // that propagate to their own Balloon component
    balloons: {
      default: [],
      type: Array
    },

    // keep the minimized ballon when the corresponding balloon is maximized
    dockKeepMaximized: {
      default: false,
      type: Boolean
    },

    // keep the balloon dock in front of the mask when a balloon is maximized
    dockBringToFront: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    classes: function classes() {
      return ['vb-set-minimized', 'vb-' + this.position, this.dockBringToFront ? 'vb-front' : ''];
    },
    minimizedBalloons: function minimizedBalloons() {
      var _this = this;

      return this.balloons.filter(function (b) {
        return b !== _this.maximizedBalloon;
      });
    },
    maximizedBalloon: function maximizedBalloon() {
      return this.balloonState.maximized;
    }
  }
});

/***/ })

},["iXgl"]);


// WEBPACK FOOTER //
// static/js/app.529909a4f886e940b16f.js